import styled, { css } from 'styled-components';
import { PremiumUnit } from './PremiumUnit';

export const UnitsForLabelAndValue = styled.div`
  display: flex;
  padding-top: 12px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  ${(props) =>
    !!props.noPadding &&
    css`
      padding: 0;
      ${PremiumUnit} {
        display: flex;
        align-items: center;
      }
    `};
`;
